import { getDomain } from 'www/utils/get-domain';
function getApiServer(){
	if(document.location.hostname.includes("localhost") && document.location.port=="3000"){
		return 'localhost.medscape.com:3000';
	}
	return `api.${getDomain()}medscape.com`;
}

export { getApiServer };